// client/src/App.js

import {
  Box,
  Flex,
  useToast,
  Text,
  Button,
} from '@chakra-ui/react';
import React from "react";
import "../App.css";
import CommonContext from '../commonContext';
import { IoChevronBack } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';

function TermsAndConditions() {


  const commonContext = React.useContext(CommonContext);
  const [logged, setLogged] = React.useState(false)

  const navigate = useNavigate();


  const handleGoBack = () => {
    navigate(-1)
  };

  React.useEffect(() => {

    commonContext.setCurrentPath("TermsAndConditions")
    commonContext.setCurrentPage("termsandconditions")

    let currentUser = JSON.parse(localStorage.getItem('currentUser'))
    let logged = currentUser !== null && currentUser !== undefined && currentUser !== "" ? true : false
    setLogged(logged)


  }, []);


  return (
    <div>
      {!logged && <Flex mt="16" ml="16" justifyContent="left" w="100%" >
        <Button mr="20px" leftIcon={<IoChevronBack />} colorScheme='green' variant='solid' onClick={() => { handleGoBack() }}>
          Indietro
        </Button>


      </Flex>}
      <Flex justifyContent="center">
        <Box p="30px" mt="2%" ml="5%" w="50%" bg="blue.200" borderRadius="lg">
          <Text fontSize="3xl" fontWeight="bold" color="black">
            Termini e condizioni di utilizzo (italiano)
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">

            1. Introduzione
          </Text>

          <Text fontSize="md" color="black">
            Questi termini e condizioni ("Termini") regolano l'utilizzo dell'applicazione mobile SempreDiCorsa ("Applicazione"). L'Applicazione è sviluppata da NovisVega Software di Marco Notari e distribuita da SEMPREdiCORSA S.a.s ("Società").
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            2. Accettazione dei Termini
          </Text>

          <Text fontSize="md" color="black">
            Accedendo o utilizzando l'Applicazione, l'utente accetta di essere vincolato dai presenti Termini. Se l'utente non accetta i presenti Termini, non deve accedere o utilizzare l'Applicazione.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            3. Modifiche ai Termini
          </Text>

          <Text fontSize="md" color="black">
            La Società si riserva il diritto di modificare i presenti Termini in qualsiasi momento. Le modifiche saranno in vigore dal momento della loro pubblicazione nell'Applicazione. L'utente è responsabile di verificare periodicamente i presenti Termini per eventuali modifiche.
          </Text>


          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            4. Account
          </Text>

          <Text fontSize="md" color="black">

            Per accedere ad alcuni contenuti aggiuntivi dell'Applicazione, l'utente deve creare un account ("Account"). Per creare un Account, l'utente deve fornire informazioni accurate e complete. L'utente è responsabile della sicurezza del proprio Account e delle attività che si svolgono tramite esso.

          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            5. Utilizzo dell'Applicazione
          </Text>

          <Text fontSize="md" color="black">
            L'utente può utilizzare l'Applicazione per visualizzare i contenuti video a disposizione. Alcuni contenuti sono disponibili senza restrizioni, altri richiedono invece il pagamento periodico di un abbonamento che conferisce lo status di "Utente PRO". Oltre alla visualizzazione dei contenuti video, l'utilizzatore può usufruire di altre funzionalità, quali il calcolo di alcuni parametri in base all'input fornito dall'utilizzatore stesso nell'ambito dei test proposti (Test dei 6 minuti, Test dei 10 km, Test dei 5 km).
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            6. Diritti di proprietà intellettuale
          </Text>

          <Text fontSize="md" color="black">
            Tutti i diritti di proprietà intellettuale sui contenuti messi a disposizione tramite l'Applicazione sono di proprietà di SEMPREdiCORSA S.a.s o dei suoi licenziatari. Tutti i diritti di proprietà intellettuale sull'Applicazione sono di proprietà di NovisVega Software di Marco Notari o dei suoi licenziatari. L'utente non può utilizzare l'Applicazione o il suo contenuto in alcun modo che non sia espressamente autorizzato dai presenti Termini.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            7. Limitazione di responsabilità
          </Text>


          <Text fontSize="md" color="black">
            La Società non è responsabile per eventuali danni indiretti, incidentali, speciali, consequenziali o punitivi derivanti dall'utilizzo dell'Applicazione. I dati e le informazioni fornite dall'applicazione sono limitati dall'impossibilità di seguire personalmente l'utente nei suoi allenamenti, quindi sono da intendersi come riferimento, non come consigli medici.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            8. Risoluzione
          </Text>

          <Text fontSize="md" color="black">
            La Società può risolvere questi Termini in qualsiasi momento, con o senza preavviso. In caso di risoluzione, l'utente deve interrompere l'utilizzo dell'Applicazione.

          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            9. Abbonamento premium

          </Text>

          <Text fontSize="md" color="black">
            L'utilizzo e/o la visione di alcuni contenuti richiedono una sottoscrizione che conferisce all'utilizzatore lo status di "Utente PRO". La sottoscrizione ha un costo mensile che può variare in base alla frequenza di pagamento scelta. L'utente non può utilizzare/visionare i contenuti indicati con l'etichetta "PRO" se non è in possesso di una sottoscrizione PRO.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            10. Trattamento dati
          </Text>

          <Text fontSize="md" color="black">
            I dati ottenuti tramite l'applicazione sono salvati e legati al profilo dell'utente registrato. I dati sono utilizzati unicamente per garantire il corretto funzionamento dell'applicazione e per personalizzare i contenuti a disposizione dell'utente stesso, come il calcolo delle zone nel test dei 6 minuti. I dati salvati non sono utilizzati per scopi diversi da quelli riportati e non sono trasmessi a terzi.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            11. Legge applicabile
          </Text>

          <Text fontSize="md" color="black">
            I presenti Termini sono regolati dalla legge italiana.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            12. Arbitrato
          </Text>


          <Text fontSize="md" color="black">
            Ogni controversia derivante dai presenti Termini sarà risolta mediante arbitrato vincolante ai sensi del Regolamento di Arbitrato della Camera di Commercio Internazionale. L'arbitrato si svolgerà a Milano, Italia, in lingua italiana.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            13. Disposizioni generali
          </Text>


          <Text fontSize="md" color="black">
            Se una qualsiasi disposizione dei presenti Termini è invalida o inapplicabile, tale disposizione sarà separata dai presenti Termini e le restanti disposizioni rimarranno in vigore.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            14. Contatti
          </Text>

          <Text fontSize="md" color="black">
            Se l'utente ha domande o reclami relativi ai presenti Termini, può contattare la Società all'indirizzo info@sempredicorsa.it.
          </Text>



          <Text mt="16" fontSize="3xl" fontWeight="bold" color="black">
            Terms and conditions of use (english)
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            1. Introduction
          </Text>

          <Text fontSize="md" color="black">
            These terms and conditions ("Terms") govern the use of the SempreDiCorsa mobile application ("Application"). The Application is developed by NovisVega Software di Marco Notari and distributed by SEMPREdiCORSA S.a.s ("Company").
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            2. Acceptance of the Terms
          </Text>

          <Text fontSize="md" color="black">
            By accessing or using the Application, you agree to be bound by these Terms. If you do not agree to these Terms, you must not access or use the Application.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            3. Changes to the Terms

          </Text>

          <Text fontSize="md" color="black">
            The Company reserves the right to change these Terms at any time. The changes will be effective from the time of their publication in the Application. You are responsible for checking these Terms periodically for changes.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            4. Account
          </Text>

          <Text fontSize="md" color="black">
            To access some additional content on the Application, you must create an account ("Account"). To create an Account, you must provide accurate and complete information. You are responsible for the security of your Account and any activities that occur through it.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            5. Use of the Application
          </Text>

          <Text fontSize="md" color="black">
            The user can use the application to view available video content. Some contents are available without restrictions, others require the periodic payment of a subscription which confers the status of "PRO User". In addition to viewing video content, the user can take advantage of other functions, such as the calculation of some parameters based on the input provided by the user himself as part of the proposed tests (6-minute test, 10 km test, of 5 km).
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            6. Intellectual Property Rights
          </Text>

          <Text fontSize="md" color="black">
            All intellectual property rights in the content made available through the Application are the property of SEMPREdiCORSA S.a.s or its licensors. All intellectual property rights in the Application are owned by NovisVega Software di Marco Notari or its licensors. You may not use the Application or its contents in any way that is not expressly authorized by these Terms.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            7. Limitation of Liability
          </Text>

          <Text fontSize="md" color="black">
            The Company is not liable for any indirect, incidental, special, consequential or punitive damages arising from the use of the Application. The data and information provided by the application are limited by the impossibility of personally following the user in his workouts, therefore they are to be understood as reference, not as medical advice.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            8. Resolution
          </Text>

          <Text fontSize="md" color="black">
            The Company may terminate these Terms at any time, with or without notice. Upon termination, you must stop using the Application.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            9. Premium membership
          </Text>

          <Text fontSize="md" color="black">
            The use and/or viewing of some contents requires a subscription which gives the user the status of "PRO User". The subscription has a monthly cost which may vary based on the payment frequency chosen. The user cannot use/view the contents labeled "PRO" if he does not have a PRO subscription.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            10. Data processing
          </Text>

          <Text fontSize="md" color="black">
            The data obtained through the application is saved and linked to the profile of the registered user. The data is used solely to guaranTermini e condizioni di utilizzo
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            11. Applicable law
          </Text>

          <Text fontSize="md" color="black">
            These Terms are governed by Italian law.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            12. Arbitration
          </Text>

          <Text fontSize="md" color="black">
            Any dispute arising under these Terms will be resolved by binding arbitration under the Arbitration Rules of the International Chamber of Commerce. The arbitration will take place in Milan, Italy, in the Italian language.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            13. General provisions
          </Text>

          <Text fontSize="md" color="black">
            If any provision of these Terms is invalid or unenforceable, that provision will be severed from these Terms and the remaining provisions will remain in effect.
          </Text>

          <Text mt="8" fontSize="xl" fontWeight="bold" color="black">
            14. Contacts
          </Text>

          <Text fontSize="md" color="black">
            If you have any questions or complaints regarding these Terms, you can contact the Company at info@sempredicorsa.it.
          </Text>
        </Box>
      </Flex>


    </div>
  );
}

export default TermsAndConditions;